import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {RELOGIN_STATE, ReloginStateService} from '@datev/ngx-dcal';
import {BehaviorSubject} from 'rxjs';
import {LoaderService} from '../../service/loader.service';

@Component({
  selector: 'diva-relogin-modal',
  templateUrl: './relogin.component.html',
  styleUrls: ['./relogin.component.scss']
})
export class ReloginComponent implements OnInit{
  @ViewChild('LoadingReloginTemplate', {static: true}) layoutTemplate: TemplateRef<unknown>;

  public states = RELOGIN_STATE;
  public currentState: BehaviorSubject<RELOGIN_STATE> = new BehaviorSubject<RELOGIN_STATE>(RELOGIN_STATE.FINE);

  constructor(private readonly reLoginStateService: ReloginStateService,
              public readonly loadingService: LoaderService) {
  }

  ngOnInit(): void {
    this.loadingService.isLoading = {isLoading: false};
    this.reLoginStateService.currentState.subscribe((reloginState: RELOGIN_STATE) => {
      this.currentState.next(reloginState);
    });
  }

  public close(): void {
    this.reLoginStateService.close();
  }

  public relogin(): void {
    this.reLoginStateService.onUserRequestedRelogin();
  }

}
